import { Card, Flex, Text } from '@radix-ui/themes';
import { ReactNode } from 'react';

const LegendItem = (props: { label: string; icon: ReactNode }) => (
  <Flex align="center" gap="2">
    {props.icon}
    <Text>{props.label}</Text>
  </Flex>
);

export const TrainingPerfLegend = () => (
  <Card>
    <Flex align="center" justify="center" gap="9">
      <LegendItem
        icon={
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="7"
              cy="7"
              r="3.75"
              fill="#D9EDFF"
              fillOpacity="0.3647"
              stroke="#F1F7FE"
              strokeOpacity="0.7098"
              strokeWidth="0.5"
            />
          </svg>
        }
        label="Machine Shot"
      />
      <LegendItem
        icon={
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="6.5"
              cy="6.5"
              r="6"
              fill="#DDEAF8"
              fillOpacity="0.0784314"
              stroke="#DFEBFD"
              strokeOpacity="0.427451"
            />
          </svg>
        }
        label="Machine Threshold"
      />
    </Flex>
  </Card>
);
